import { render } from "./ChevronRight.vue?vue&type=template&id=e7faa312"
const script = {}
script.render = render

export default script